module.exports = __webpack_public_path__ + "img/Editor.df2c3ccc.png";